import { useEffect, useState } from 'react'
import {
  SearchResponseInterface,
  SearchResultInterface,
} from 'common/types/search-interfaces'
import { getSearch } from 'publisher/api/search-api'
import { managementSelectors, useManagement } from 'publisher/store'
import { searchResultsData } from 'common/components/entities/search-results/utils'
import useBlog, { selectors } from 'publisher/hooks/useBlog'

interface UseBlogSearchProps {
  limit?: number
}

interface SearchResultsInterface
  extends SearchResponseInterface<SearchResultInterface> {
  pages: number
}

interface SearchParamsInterface {
  query: null | string
  page: null | string
  limit: null | string
}

export const useBlogSearch = ({ limit = 10 }: UseBlogSearchProps) => {
  const isPreview = useManagement(managementSelectors.isPreview)
  const blogPath: string = useBlog(selectors.getBlogPath)
  const [error, setError] = useState<unknown>(null)
  const [isFetching, setIsFetching] = useState(false)

  const getPreviewSearchResults = (): SearchResultsInterface => ({
    page: 1,
    pages: 3,
    total: 45,
    data: searchResultsData(limit),
  })

  const [searchResults, setSearchResults] =
    useState<SearchResultsInterface | null>(
      isPreview ? getPreviewSearchResults() : null,
    )

  const fetch = async (params: SearchParamsInterface) => {
    setIsFetching(true)
    try {
      const data = await getSearch({
        blogPath,
        query: params.query,
        limit: params.limit ? params.limit : limit.toString(),
        page: params.page,
      })

      setSearchResults({
        ...data,
        pages: Math.ceil(data.total / (params.limit ? +params.limit : limit)),
      })
    } catch (error) {
      setError(error)
    } finally {
      setIsFetching(false)
    }
  }

  useEffect(() => {
    const params = new URLSearchParams(document.location.search)

    fetch({
      query: params.get('query'),
      page: params.get('page'),
      limit: params.get('limit'),
    })
  }, [])

  return { searchResults, isFetching, error, fetch, isPreview }
}
